import { Typography } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Button from "@material-ui/core/Button"
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'
import lodashGet from 'lodash.get'
import {ConfirmationDialog, useConfirmationDialogController} from "../../presentation/confirmation-dialog";

const useStyles = makeStyles((theme) => ({
    cell: {
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
    },
    container: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(0.5),
    },
    errorBorder: {
        borderColor: theme.palette.error.main,
    },
    errorText: {
        color: theme.palette.error.dark,
    },
    saveButton: {
        margin: "1rem",
        height: "2rem"
    },
    inputsWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: 'center'
    },
    buttonsWrapper: {
        display: "flex",
        width: "100%",
        justifyContent: "space-evenly"
    },
    withMargin: {
        marginTop: "8px"
    }
}))

const CanvasSsoFeatureToggle = ({ name, description, feat, errorMsg, updateCanvasSso, deleteCanvasSso}) => {
    const classes = useStyles()
    const [isSsoEnabled, setIsSsoEnabled] = useState(false);
    const [identityProvider, setIdentityProvider] = useState('');
    const [domain, setDomain] = useState('');
    const [canvasSsoUpdated, setCanvasSsoUpdated] = useState(false);

    const onConfirmSave = () => updateCanvasSso({enabled: true, identityProvider, domain})
    const saveDialogController = useConfirmationDialogController({ onConfirm: onConfirmSave })
    const saveConfirmMsg = `Are you sure you want to ${feat ? 'update' : 'enable'} Canvas SSO?`

    const onConfirmDelete = () => deleteCanvasSso()
    const deleteDialogController = useConfirmationDialogController({ onConfirm: onConfirmDelete })
    const deleteConfirmMsg = `Are you sure you want to disable Canvas SSO?`

    useEffect(() => {
        setIsSsoEnabled(lodashGet(feat, 'enabled', false))
        setIdentityProvider(lodashGet(feat, 'identityProvider', ''))
        setDomain(lodashGet(feat, 'domain', ''))
        setCanvasSsoUpdated(errorMsg)
    }, [feat, errorMsg])

    const onChangeIdentityProvider = async (event) => {
        const newValue = event.target.value;

        setIdentityProvider(newValue)
        if(domain && newValue){
            setIsSsoEnabled(true)
        }
        setCanvasSsoUpdated(true)
    }

    const onChangeDomain = async (event) => {
        const newValue = event.target.value;

        setDomain(newValue)
        if(identityProvider && newValue){
            setIsSsoEnabled(true)
        }
        setCanvasSsoUpdated(true)
    }

    return (
        <Paper {...getContainerProps(errorMsg)}>
            <ConfirmationDialog message={saveConfirmMsg} controller={saveDialogController} />
            <ConfirmationDialog message={deleteConfirmMsg} controller={deleteDialogController} />
            <Grid container>
                <Grid className={classes.cell} item xs={3}>
                    <Typography variant="body1">{name}</Typography>
                </Grid>
                <Grid className={classes.cell} item xs={6}>
                    <Typography variant="body1" align="center">
                        {description}
                        <br />
                        <Typography variant="caption" align="center" gutterBottom="true">
                            * Please contact a developer before enabling this feature, as it requires set up with the customer's external identity provider before this will work.
                            After the development work has been done to add the external provider, the identity provider name must match the name defined during the set up process.
                        </Typography>
                    </Typography>


                </Grid>
                <Grid className={classes.inputsWrapper} item xs={3}>
                    <label>Domain:</label>
                    <input
                        placeholder="Domain"
                        value={domain}
                        onChange={onChangeDomain}
                    />
                    <label className={classes.withMargin}>Identity Provider:</label>
                    <input
                        placeholder="Identity provider"
                        value={identityProvider}
                        onChange={onChangeIdentityProvider}
                    />
                    <div className={classes.buttonsWrapper}>
                        <Button
                            className={classes.saveButton}
                            color="primary"
                            variant="contained"
                            disabled={!canvasSsoUpdated || !isSsoEnabled}
                            onClick={saveDialogController.openDialog}
                        >
                            {feat ? 'Update' : 'Save'}
                        </Button>
                        {feat && (
                            <Button
                                className={classes.saveButton}
                                color="secondary"
                                variant="contained"
                                onClick={deleteDialogController.openDialog}
                            >
                                Delete
                            </Button>
                        )}
                    </div>
                </Grid>
            </Grid>
            {errorMsg ? (
                <Grid item xs={12}>
                    <Typography variant="body1" align="center" className={classes.errorText}>
                        {errorMsg}
                    </Typography>
                </Grid>
            ) : (
                <></>
            )}
        </Paper>
    )
}

const getContainerProps = (errorMsg) => {
    const classes = useStyles()

    return {
        className: classes.container + (errorMsg ? ' ' + classes.errorBorder : ''),
        variant: errorMsg ? 'outlined' : undefined,
        elevation: 0,
    }
}

export default CanvasSsoFeatureToggle
